import store from '@/store/index'

export default {}

/**
 * Returns the full state object for the specified module.
 *
 * @param module String
 *
 * @returns Object
 */
export const get = (module) => {
  return store.getters[`${module}/get`]
}

/**
 * Returns an array of contacts for the specified module.
 *
 * @param module String
 *
 * @returns Array
 */
export const contacts = (module) => {
  return store.getters[`${module}/contacts`]
}

/**
 * Returns the number of contacts.
 *
 * @param module String
 *
 * @returns Number
 */
export const contactsCount = (module) => {
  return store.getters[`${module}/contacts`].length
}

/**
 * Finds and returns a contact by id or undefined if not found.
 *
 * @param module String
 * @param id     Number
 *
 * @returns Array
 */
export const contactById = (module, id) => {
  return store.getters[`${module}/contacts`].find(
    contact => contact.id === id
  )
}

/**
 * Finds and returns a contact by index or undefined if not found.
 *
 * @param module String
 * @param index  Number
 *
 * @returns Array
 */
export const contactByIndex = (module, index) => {
  let contacts = store.getters[`${module}/contacts`]
  if (index < contacts.length) {
    return contacts[index]
  } else {
    return undefined
  }
}

/**
 * Returns the current form warning.
 *
 * @param module String
 *
 * @return string
 */
export const warning = (module) => {
  return store.getters[`${module}/warning`]
}

/**
 * Returns the newest (last) contact in the list of contacts.
 *
 * @param module String
 *
 * @returns Object
 */
export const newest = (module) => {
  return contacts[store.getters[`${module}/get`].length - 1]
}

/**
 * Returns the contact types.
 *
 * @param module String
 *
 * @returns Object
 */
export const contactTypes = (module) => {
  return store.getters[`${module}/contactTypes`]
}

/**
 * API request to create a new contact. The payload must be in the format:
 * { url: String, data: Object }
 *
 * @param module  String
 * @param payload Object
 */
export const post = (module, payload) => {
  return store.dispatch(`${module}/post`, payload)
}

/**
 * API request to update an existing contact. The payload must be in the format:
 * { url: String, data: Object }
 *
 * @param module  String
 * @param payload Object
 */
export const put = (module, payload) => {
  return store.dispatch(`${module}/put`, payload)
}

/**
 * API request to delete an existing contact. The payload must be in the format:
 * { url: String, data: Object }
 *
 * @param module  String
 * @param payload Object
 */
export const deleteContact = (module, payload) => {
  return store.dispatch(`${module}/delete`, payload)
}

/**
 * Set an array of contacts.
 *
 * @param module   String
 * @param contacts Array
 */
export const setContacts = (module, contacts) => {
  store.commit(`${module}/setContacts`, contacts)
}

/**
 * Set the contact types.
 *
 * @param module       String
 * @param contactTypes Object
 */
export const setContactTypes = (module, contactTypes) => {
  store.commit(`${module}/setContactTypes`, contactTypes)
}

/**
 * Add a new contact.
 *
 * @param module  String
 * @param contact Object
 */
export const add = (module, contact) => {
  store.commit(`${module}/add`, contact)
}

/**
 * Updates an existing contact.
 *
 * @param module  String
 * @param contact Object
 */
export const update = (module, contact) => {
  store.commit(`${module}/update`, contact)
}

/**
 * Find a contact by index in the array of contacts and updates it.
 *
 * @param module  String
 * @param contact Object
 * @param index   Number
 */
export const updateByIndex = (module, contact, index) => {
  store.commit(`${module}/updateByIndex`, { contact, index })
}

/**
 * Updates the last contact that was added.
 *
 * @param module  String
 * @param contact Object
 */
export const updateNewest = (module, contact) => {
  store.commit(`${module}/updateNewest`, contact)
}

/**
 * Find a contact by id and remove it.
 *
 * @param module  String
 * @param id      Number
 */
export const removeById = (module, id) => {
  store.commit(`${module}/removeById`, id)
}

/**
 * Find a contact by id and remove it.
 *
 * @param module  String
 * @param index   Number
 */
export const removeByIndex = (module, index) => {
  store.commit(`${module}/removeByIndex`, index)
}

/**
 * Clears both the contacts and contact types from the state.
 *
 * @param module String
 */
export const purge = (module) => {
  store.commit(`${module}/purge`)
}

/**
 * Purge the contacts only and not the contact types.
 *
 * @param module String
 */
export const purgeContacts = (module) => {
  store.commit(`${module}/purgeContacts`)
}

/**
 * Sets the isAdding form state.
 *
 * @param module   String
 * @param isAdding Boolean
 */
export const setIsAdding = (module, isAdding) => {
  store.commit(`${module}/setIsAdding`, isAdding)
}

/**
 * Sets the isEditing form state.
 *
 * @param module   String
 * @param isEditing Boolean
 */
export const setIsEditing = (module, isEditing) => {
  store.commit(`${module}/setIsEditing`, isEditing)
}

/**
 * Sets the isDeleting form state.
 *
 * @param module   String
 * @param isDeleting Boolean
 */
export const setIsDeleting = (module, isDeleting) => {
  store.commit(`${module}/setIsDeleting`, isDeleting)
}

/**
 * Sets the form warning.
 *
 * @param module  String
 * @param warning String
 */
export const setWarning = (module, warning) => {
  store.commit(`${module}/setWarning`, warning)
}

/**
 * Resets the form state.
 *
 * @param module   String
 */
export const resetFormState = (module) => {
  store.commit(`${module}/resetFormState`)
}



// WEBPACK FOOTER //
// ./src/store/contacts/contacts.helpers.js